import { render } from "./c-columns.vue?vue&type=template&id=3196fd9f"
import script from "./c-columns.vue?vue&type=script&lang=js"
export * from "./c-columns.vue?vue&type=script&lang=js"

import "./c-columns.vue?vue&type=style&index=0&id=3196fd9f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__